"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propType = exports.render = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactIs = require("react-is");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var mergeTypes = {
  passive: function passive(originalProps, newProps) {
    return (0, _extends2.default)({}, newProps, originalProps);
  },
  aggressive: function aggressive(originalProps, newProps) {
    return newProps;
  },
  none: function none() {
    return {};
  }
};
var defaultOpts = {
  mergeType: 'passive'
};

var render = function render(Renderer, props) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _defaultOpts$opts = (0, _extends2.default)({}, defaultOpts, opts),
      mergeType = _defaultOpts$opts.mergeType;

  (0, _invariant.default)(mergeType === 'passive' || mergeType === 'aggressive' || mergeType === 'none', "CustomRenderer: invalid merge type (expected aggressive|passive|none, got " + mergeType + ")");

  if (_react.default.isValidElement(Renderer)) {
    return (0, _react.cloneElement)(Renderer, mergeTypes[mergeType](Renderer.props, props));
  }

  if ((0, _reactIs.isValidElementType)(Renderer)) {
    return _react.default.createElement(Renderer, props);
  }

  return Renderer;
};

exports.render = render;

var propType = _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.node]);

exports.propType = propType;